export default __webpack_public_path__ + "static/media/curation2.e2b7b163.wav";